"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ForbiddenImage = require("./ForbiddenImage");
Object.keys(_ForbiddenImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ForbiddenImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ForbiddenImage[key];
    }
  });
});
var _NotFoundImage = require("./NotFoundImage");
Object.keys(_NotFoundImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotFoundImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotFoundImage[key];
    }
  });
});
var _ServerErrorImage = require("./ServerErrorImage");
Object.keys(_ServerErrorImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServerErrorImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServerErrorImage[key];
    }
  });
});
var _UnauthorizedImage = require("./UnauthorizedImage");
Object.keys(_UnauthorizedImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UnauthorizedImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UnauthorizedImage[key];
    }
  });
});